// saved for later
// import config from 'config';
import {listTeams} from './mockData/MockTeamAndPlayerData'


const LOAD = 'footballteamlist/LOAD';
const LOAD_SUCCESS = 'footballteamlist/LOAD_SUCCESS';
const LOAD_FAIL = 'footballteamlist/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        teams: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.football
      && globalState.football.teamList
      && globalState.football.teamList.loading;
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    // saved for later
    // promise: (client) => client.get(`${config.api.football.vidiprinter}`)
    promise: () => Promise.resolve(listTeams())
  };
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/teamList.js